const tests = require('./grammartests.json')
//const tests = require('./polishgrammartests.json')

function shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
}

const tagMap = {
  "sv": "Singular vocative",
  "sn": "Singular nominative",
  "sl": "Singular locative",
  "si": "Singular instrumentive",
  "sg": "Singular genitive",
  "sd": "Singular dative",
  "sa": "Singular accusative",
  "pv": "Plural vocative",
  "pn": "Plural nominative",
  "pl": "Plural locative",
  "pi": "Plural instrumentive",
  "pg": "Plural genitive",
  "pd": "Plural dative",
  "pa": "Plural accusative",
}

const getRemainingChoices = (alreadyChosen, max) => {
  let remainingChoices = []
  for(var i=0; i<max; i++){
    if(!alreadyChosen.has(i)){
      remainingChoices.push(i)
    }
  }
  return remainingChoices
}

const buildAnswers = (alreadyChosen) => {
    let remainingChoices = getRemainingChoices(alreadyChosen, tests["tests"].length)
    if(remainingChoices.length == 0){
      alreadyChosen = new Set()
      remainingChoices = getRemainingChoices(alreadyChosen, tests["tests"].length)
    }
    let currentAnswerIndex = remainingChoices[Math.floor(Math.random()*remainingChoices.length)];
    alreadyChosen.add(currentAnswerIndex)
    let test = tests["tests"][currentAnswerIndex];
    let wordDefinition = tests["words"][test["word"]]
    let declensionMap = wordDefinition["declensions"];
    let declensions = Array.from(
      new Set(
        Object.entries(
          wordDefinition["declensions"]
        ).map(
          function (entry){
            return entry[1]
          }
        )
      )
    )
    let correctAnswer = declensionMap[test["tag"]]
    shuffle(declensions);

    // get top 3 answers that aren't the correct one
    let all_answers = [];

    for(var i=0; all_answers.length<3 && i<declensions.length; i++){
      let answer = declensions[i];
      if(answer != correctAnswer){
        all_answers.push(answer)
      }
    }

    all_answers.push(correctAnswer)
    shuffle(all_answers)

    let prompt = test["prompt"].replace(/\(\)/, "(" + test["word"] + ")");
    let correctSentence = test["prompt"].replace(/\(\)/, correctAnswer)

    return {
      selectedAnswer: null,
      checkAnswers: false,
      prompt: prompt,
      translation: test["translation"],
      explanation: tagMap[test["tag"]],
      correctSentence: correctSentence,
      correctAnswer: correctAnswer,
      allAnswers: all_answers,
      word: test["word"],
      wordDefinition: wordDefinition,
      alreadyChosen: alreadyChosen,
    };
}

export { buildAnswers }